import { render, staticRenderFns } from "./addLoginTypeConfiguration.vue?vue&type=template&id=81a0a61c&"
import script from "./addLoginTypeConfiguration.vue?vue&type=script&lang=js&"
export * from "./addLoginTypeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./addLoginTypeConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a0a61c')) {
      api.createRecord('81a0a61c', component.options)
    } else {
      api.reload('81a0a61c', component.options)
    }
    module.hot.accept("./addLoginTypeConfiguration.vue?vue&type=template&id=81a0a61c&", function () {
      api.rerender('81a0a61c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addLoginTypeConfiguration.vue"
export default component.exports